import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "c_flex_row header-menu__item" }
const _hoisted_2 = { class: "c_font14" }

import { onMounted, reactive, computed, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import shared from '@/micro/shared'
import { IWorkBenchItem } from '@y/types'
import initApps from '@/micro'


export default /*@__PURE__*/_defineComponent({
  __name: 'Menus',
  setup(__props) {

const router = useRouter()
const appName = computed(() => shared.getAppName())

let menus: IWorkBenchItem[] = reactive([
  {
    label: '工作台',
    name: 'admin',
    path: '/work-bench',
    icon: 'bar-chart-box-ai-fill',
    isContainerMenu: true,
  },
])

onMounted(() => {
  initMenus()
})

const redirectUrl = (url: string) => {
  sessionStorage.removeItem('redirect')
  nextTick(() => {
    router.replace(url)
  })
}

// 查询数据
const initMenus = async () => {
  const storageMenus = shared.getWorkBenchMenus()
  const redirect = sessionStorage.getItem('redirect')
  if (storageMenus && storageMenus.length > 0) {
    menus = storageMenus
    initApps()
    if (redirect) {
      nextTick(() => {
        redirectUrl(redirect)
      })
    }
    return
  }
  const data = shared.getRouters()
  if (data && data.children && data.children?.length > 0) {
    const user = shared.getUser()
    const resources = user?.resources
    data.children.forEach(child => {
      const { code, type } = child
      if (resources?.includes(code) && ['1', '5'].includes(type)) {
        const { text, urlPath, attributes } = child
        const item = {
          label: text,
          name: urlPath.replace('/', ''),
          path: urlPath,
          icon: attributes?.resourceIcon || 'apps',
          isContainerMenu: true,
        }
        if (type === '5') {
          item.isContainerMenu = false
        }
        menus.push(item)
      }
    })
    shared.setWorkBenchMenus(menus)
    initApps()
    if (redirect) {
      nextTick(() => {
        redirectUrl(redirect)
      })
    }
  }
}

const handleClickMenu = (menu: IWorkBenchItem) => {
  const { isContainerMenu } = menu
  let path = menu.path
  if (!isContainerMenu) {
    path = `/app${menu.path}/`
  }
  router.push(path)
}

return (_ctx: any,_cache: any) => {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    ellipsis: false,
    class: "header-menu c_font14",
    mode: "horizontal",
    "popper-offset": 16,
    style: {"max-width":"800px"},
    "default-active": appName.value
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menus), (menu) => {
        return (_openBlock(), _createBlock(_component_el_menu_item, {
          key: menu.name,
          index: menu.name,
          class: "c_padding_l5 c_padding_r5",
          onClick: ($event: any) => (handleClickMenu(menu))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_app_icon, {
                class: "c_margin_r5",
                name: menu.icon,
                color: "var(--app-color-text)"
              }, null, 8, ["name"]),
              _createElementVNode("span", _hoisted_2, _toDisplayString(menu.label), 1)
            ])
          ]),
          _: 2
        }, 1032, ["index", "onClick"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["default-active"]))
}
}

})